"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _proptypes = require("../utils/proptypes");

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Icon(props) {
  var children = props.children,
      prefix = props.prefix,
      type = props.type,
      name = props.name,
      fontFamily = props.fontFamily,
      fontSize = props.fontSize,
      otherProps = _objectWithoutPropertiesLoose(props, ["children", "prefix", "type", "name", "fontFamily", "fontSize"]);

  var className = (0, _classnames.default)((0, _styles.iconClass)('_', type), props.className, prefix + "-" + name);
  var style = Object.assign({}, {
    fontFamily: fontFamily,
    fontSize: fontSize
  }, props.style);
  return _react.default.createElement("i", _extends({}, otherProps, {
    className: className,
    style: style
  }), children);
}

Icon.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default, 'children', 'size', 'type'), {
  prefix: _propTypes.default.string,
  name: _propTypes.default.string,
  fontFamily: _propTypes.default.string,
  fontSize: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
});
Icon.defaultProps = _objectSpread({}, _proptypes.defaultProps, {
  prefix: 'icon',
  fontFamily: 'iconfont',
  name: '',
  type: 'default'
});
Icon.displayName = 'ShineoutIcon';
var _default = Icon;
exports.default = _default;